export default __webpack_public_path__ + "static/media/Artist3.76d72800.svg";